import { InputText } from "primereact/inputtext";
import { REGEX } from "../../constants/regex";

const StudentInformation = ({ props, nameError, setNameError, emailError, setEmailError }) => {
  const { studentInfo, setStudentInfo, translations, invalidMessage } = props;
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStudentInfo((prev) => ({ ...prev, [name]: value }));

    if (name === "recipientName") {
      setNameError(value ? "" : invalidMessage.requiredField);
    }

    if (name === "email") {
      if (!value) {
        setEmailError(invalidMessage.requiredField);
      } else {
        setEmailError(REGEX.EMAIL.test(value) ? "" : invalidMessage.invalidEmail);
      }
    }
  };

  return (
    <div className="flex flex-column gap-3 keduall-typography text-16-normal-400">
      {/* Student Name */}
      <div className="flex flex-column gap-0125">
        <label className="keduall-typography text-14-normal-400 required">{translations.studentNameLabel}</label>
        <InputText
          className="keduall-form input-default-default keduall-typography text-default-txt"
          name="recipientName"
          value={studentInfo.recipientName ?? ""} 
          onChange={handleInputChange} 
          placeholder={translations.enterStudentNamePlaceholder}
        />
        {nameError && <small className="p-error">{nameError}</small>}
      </div>

      {/* Student Email */}
      <div className="flex flex-column gap-0125">
        <label className="keduall-typography text-14-normal-400 required">{translations.studentEmailLabel}</label>
        <InputText
          className="keduall-form input-default-default keduall-typography text-default-txt"
          name="email"
          value={studentInfo.email ?? ""} 
          onChange={handleInputChange}
          placeholder={translations.enterStudentEmailPlaceholder}
        />
        {emailError && <small className="p-error">{emailError}</small>}
      </div>
    </div>
  );
};

export default StudentInformation;
